import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCountdownTimer } from "@/react/hooks/useCountdownTimer";
import { planSettingsPath } from "@circle-react/helpers/urlHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";

const localeRoot = "trial_banner.marketing_campaign";

export const MarketingCampaignOffer = () => {
  const history = useHistory();

  const handleOnClick = () => {
    history.push(planSettingsPath());
  };

  const expiringInTimer = useCountdownTimer({
    endDate: "2025-12-04T05:00:00Z",
  });

  return (
    <div>
      <div className="flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm
          weight="font-semibold"
          color="text-white"
          size="text-base"
        >
          {t(`${localeRoot}.title`)}
        </Typography.BodySm>
        {expiringInTimer && (
          <Typography.BodySm
            weight="font-normal"
            color="text-white"
            size="text-base"
          >
            {t("trial_banner.expiring_in", {
              expiring_in_timer: expiringInTimer,
            })}
          </Typography.BodySm>
        )}

        <Button
          className="ml-1 text-base font-semibold"
          variant="secondary"
          onClick={handleOnClick}
        >
          {t(`${localeRoot}.cta`)}
        </Button>
      </div>
    </div>
  );
};
